// Import dependencies
import $ from 'jquery'
import Hammer from 'hammerjs'

// Import styles
import './styles/index.scss'

// Make jQuery and Hammer available globally for the legacy code
window.$ = window.jQuery = $
window.Hammer = Hammer

// Import the main application code
import './index.js'